<template>
    <div>
        <form @submit.prevent="doLogin">
            <div class="form-group">
                <label for="username">Username</label>
                <input type="text" id="username" class="form-control" v-model="username">
            </div>
            <div class="form-group">
                <label for="password">Password</label>
                <input type="password" id="password" class="form-control" v-model="password">
            </div>

            <div v-if="error" class="alert alert-danger">
                {{ error }}
            </div>

            <button class="btn btn-success btn-lg" type="submit" style="width: 100%">Login</button>
        </form>
    </div>
</template>

<script>

export default {
    name: 'login-form',
    data() {
        return {
            loading: false,
            error: null,
            username: null,
            password: null,
        };
    },
    methods: {
        doLogin() {
            this.error = null;

            if (!this.username || !this.password) {
                return this.loginError('Inserire username e password');
            }

            this.$oauth2
                .loginWithCredentials(this.username, this.password)
                .then(me => {
                    this.loginSuccess(me);
                })
                .catch(() => this.loginError('Username o password non corrette'))
                .finally(() => this.loading = false)
            ;
        },
        loginError(msg) {
            this.error = msg;
        },
        loginSuccess(user) {
            this.$emit('login', user);
        },
    },
};

</script>
